var youboralib = require('youboralib')

module.exports = {
  isUsed: function (adapter) {
    return !!adapter.getTech().hls
  },

  getBitrate: function (adapter) {
    var ret = null
    var media = adapter.getTech().hls.playlists.media()
    if (adapter.player.qualityLevels) {
      // using videojs-contrib-quality-levels
      // https://github.com/videojs/videojs-contrib-quality-levels
      var qualityLevels = adapter.player.qualityLevels()
      var selected = qualityLevels[qualityLevels.selectedIndex]
      if (selected) {
        ret = selected.bitrate
      }
    }
    if (!ret && media && media.attributes) {
      ret = media.attributes.BANDWIDTH
    }
    return ret
  },

  getRendition: function (adapter) {
    var ret = null
    var media = adapter.getTech().hls.playlists.media()
    if (adapter.player.qualityLevels) {
      // using videojs-contrib-quality-levels
      // https://github.com/videojs/videojs-contrib-quality-levels
      var qualityLevels = adapter.player.qualityLevels()
      var selected = qualityLevels[qualityLevels.selectedIndex]
      if (selected) {
        ret = youboralib.Util.buildRenditionString(selected.width, selected.height, selected.bitrate)
      }
    } else if (media && media.attributes) {
      var att = media.attributes
      if (att.RESOLUTION) {
        ret = youboralib.Util.buildRenditionString(
          att.RESOLUTION.width,
          att.RESOLUTION.height,
          att.BANDWIDTH
        )
      } else if (att.BANDWIDTH) {
        ret = youboralib.Util.buildRenditionString(att.BANDWIDTH)
      } else if (att.NAME) {
        ret = att.NAME
      }
    }
    return ret
  }
}
